export const API_DATE_FORMAT = "YYYYMMDDHHmmss";
export const API_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const API_ONLY_DATE_FORMAT = "YYYYMMDD";
export const API_LIMIT_MAX = 2000;
